import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {Input, Icon} from 'semantic-ui-react';
import ReactDatePicker from 'react-datepicker';
import moment from 'moment';

import {DateFormatContext} from 'Common/DictionaryContext';
import {UserContext} from 'Common/Context';

const DateInput = React.forwardRef((props, ref) => {
  const {onInputChange, onChange, ...otherProps} = props;
  const handleChange = e => {
    if (onInputChange) onInputChange(e.target.value);
    if (onChange) onChange(e);
  };

  return (
    <Input
      {...otherProps}
      ref={ref}
      icon={
        <Icon
          name="calendar alternate outline"
          size="large"
          style={{width: 32}}
        />
      }
      onChange={handleChange}
    />
  );
});

const DatePicker = props => {
  let {dateFormat} = useContext(DateFormatContext);
  const {timezone} = useContext(UserContext);

  dateFormat = dateFormat.replace(/ddd/g, 'iii').replace(/D/g, 'd');

  const handleChange = date => {
    props.onChange(date);
  };

  return (
    <ReactDatePicker
      customInput={<DateInput onInputChange={props.onStringChange} />}
      dateFormat={dateFormat}
      dropdownMode="select"
      onChange={handleChange}
      popperModifiers={{
        preventOverflow: {
          enabled: true,
          escapeWithReference: false,
          boundariesElement: 'viewport',
        },
      }}
      popperPlacement="top-start"
      showMonthDropdown={true}
      showYearDropdown={true}
      {...props}
      selected={
        props.selected
          ? props.selected
          : props.dateValue
            ? typeof props.dateValue === 'string'
              ? new Date(moment.tz(props.dateValue, timezone).format())
              : props.dateValue
            : props.dateString
              ? props.localtime
                ? new Date(props.dateString)
                : new Date(
                    moment
                      .utc(props.dateString)
                      .tz(timezone)
                      .format(),
                  )
              : undefined
      }
    />
  );
};

DatePicker.defaultProps = {
  dateString: null,
  localtime: false,
  onStringChange: null,
};

DatePicker.propTypes = {
  dateValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]),
  dateString: PropTypes.string,
  localtime: PropTypes.bool,

  //functions
  onChange: PropTypes.func.isRequired,
  onStringChange: PropTypes.func,
};

export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/Common/Form/DatePicker.js